export const Pagination = {
    COURSES: 20,
    LIVE_EVENTS: 20,
    LIVE_EVENT_QUESTIONS: 20,
    INVOICES: 15,
    SHORTS: 10,
    COURSE_COMMENTS_INITIAL: 3,
    COURSE_COMMENTS_PAGINATED: 10,
    SEARCH_CONTENT: 10,
    TRAINERS: 100,
    CONTINUE_WATCHING: 20,
    NOTIFICATION_FEED: 20,
};
